import React, { Component } from 'react';
import { Tabs, Table, message,Button } from 'antd';
import Request from "../../../../networkReq/request";
import Http from "../../../../networkReq/http"
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { columns1,  columns2,  } from "./fieldConfig";
import { TableContainer, WrapContainer, ShowBaseInfo, ShowBaseInfo2 } from "./components";
import './index.scss'
const { TabPane } = Tabs;

// import Request from "../../../networkReq/request";
// import Http from "../../../networkReq/http"
export default class ResumeManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDetail: false,
            columns1: columns1(this.renderOperation),
            data1:{},
            columns2: columns2(this.renderOperation),
            data2:{},
            currentDetail: '',
            counselingMessage: '',
            loading: false,
            activeKey: 1,
            imageUrl: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg',
            // rules: {
            //     oldPassword: [
            //         { required: true, message: '请输入旧密码', trigger: 'blur' },
            //         {
            //             validator: (rule, value, callback) => {
            //                 if (value === '') {
            //                     callback(new Error('请输入旧密码'));
            //                 } else {
            //                     callback();
            //                 }
            //             }
            //         }
            //     ],
            // }
        }
    }

    onChange = (activeKey) => {
        console.log('------onChange------', activeKey);
        this.setState({activeKey})
        this.search({isIncorporation: activeKey})
    }

    renderOperation = (text, record, index) => {

        return <div>
            <a onClick={() => this.viewDetails(text, record, index)}>查看</a>
        </div>
    }

    viewDetails = (text, record, index) => {
        console.log('------viewDetails------', record);
        const { history } = this.props;
        let  counselingMessage= [
            { label: '咨询内容', value: record['inquiryContent'] },
            { label: '信息状态', value: record['inquiryMessageState']=='1'?'已回复':'未回复' },
            { label: '专家回复', value: record['inquiryMessageContent'] },
        ]
        if(record.isIncorporation=='1'){
            history.push({
                pathname: '/entrance/personal/businessTourDetails', state: {
                    currentDetail: [
                        { label: '申请人', value: record['inquiryName'] },
                        // { label: '身份证号', value: record['inquiryCard'] },
                        { label: '联系电话', value: record['inquiryTel'] },
                        { label: '公司名称', value: record['inquiryCompanyName'] },
                        { label: '区县', value: record['chooseCounty'] },
                        { label: '公司地址', value: record['inquiryCompanyAddress'] },
                        { label: '统一社会信用代码', value: record['socialCreditCode'] }
                    ],
                    counselingMessage
                }
            })
        }else{
            history.push({
                pathname: '/entrance/personal/businessTourDetails', state: {
                    currentDetail: [
                        { label: '申请人', value: record['inquiryName'] },
                        // { label: '身份证号', value: record['inquiryCard'] },
                        { label: '联系电话', value: record['inquiryTel'] },
                        { label: '项目名称', value: record['inquiryProjectName'] },
                        { label: '区县', value: record['chooseCounty'] },
                        { label: '创业地址', value: record['entrepreneurshipAddress'] },
                    ],
                    counselingMessage
                }
            })
        }
       
    }
    componentDidMount(){
        const {activeKey} =this.state;
         this.search({isIncorporation: '1'})
    }
    search=(param)=>{
        Http.get(Request.getSybepalexpertinquiryapplyList(),param, obj => {
            if (obj.code == 200) {
               if(param.isIncorporation=='0'){
                this.setState({data2:obj.data})
               }else {
                this.setState({data1:obj.data})
               }
              }
          });
    }
    handlePage = (page, pageSize) => {
        this.search({isIncorporation: this.state.activeKey,current:page})
     };
    render() {
        const { columns1, data1, columns2, data2, showDetail, currentDetail, counselingMessage } = this.state
        return (
            <div className="business_tour">
                {!showDetail
                    ? <Tabs defaultActiveKey="1" onChange={this.onChange}>
                        <TabPane tab="已成立公司" key="1">
                            <TableContainer columns={columns1} data={data1?.records}  
                            // pagination={{
                            //     total:data1.total,
                            //     current: data1.current,
                            //     onChange: this.handlePage,
                            //     showQuickJumper: {
                            //     goButton: <Button className={"pagination_jump"}>确定</Button>,
                            //     },
                            //     showTotal: (total) => `共 ${total} 条`,
                            //     showSizeChanger: true,
                            // }}
                              pagination={{
                                showTotal: total => `共 ${data1.total} 条`,
                                showQuickJumper: true,
                                position: ['bottomCenter'],
                                pageSize: 10,
                                current: data1.current,
                                // pageSizeOptions:['10'],
                                // size: 'small',
                                showSizeChanger: false,
                                hideOnSinglePage: true
                            }}
                             />
                        </TabPane>
                        <TabPane tab="未成立公司" key="0">
                            <TableContainer columns={columns2} data={data2?.records}
                             pagination={{
                                total:data2.total,
                                current: data2.current,
                                onChange: this.handlePage,
                                showQuickJumper: {
                                goButton: <Button className={"pagination_jump"}>确定</Button>,
                                },
                                pageSize: 10,
                                showTotal: (total) => `共 ${total} 条`,
                                showSizeChanger: false,
                                hideOnSinglePage: true
                            }}
                            />
                        </TabPane>
                    </Tabs>
                    : <div className='view_detail'>
                        <WrapContainer title='申请人信息'>
                            <ShowBaseInfo data={currentDetail} />
                        </WrapContainer>
                        <WrapContainer title='咨询信息'>
                            <ShowBaseInfo2 data={counselingMessage} />
                        </WrapContainer>
                    </div>
                    
                }
            </div>
        )
    }
}